import { DataDRequest } from "../../../data/DRequest";
import { MCicloEscolar } from "../../../data/model/MCicloEscolar";
import { _DICC_CICLO_ESCOLAR } from "../../../data/modulo/CicloEscolar";
import { _SvEscuelaActualizarLogo } from "../../../data/modulo/Escuela";
import { DataModuloMain } from "../../../data/ModuloMain";
import { UIUtilLang } from "../../util/Language";
import { UIUtilTime } from "../../util/Time";
import { IEscuelaForm } from "./EscuelaForm";

export namespace UIUtilViewEscuelas {

    export function _BuildDirectionString(escuela: Partial<IEscuelaForm>) {
        let splitDirection = escuela.Direccion.split("\n");

        if (splitDirection.length == 8) {
            let numInterior = splitDirection[0];
            let calle = splitDirection[1];
            let numExterior = splitDirection[2];
            let codigoPostal = splitDirection[3];
            let ciudad = splitDirection[4];
            let estado = splitDirection[5];
            let pais = splitDirection[6];
            // FIX_LANGUAGE
            return `${calle}, No. exterior ${numExterior}${numInterior ? ", No. interior " + numInterior : ""}, CP. ${codigoPostal}, ${ciudad}, ${estado}, ${pais}`;
        }
        return escuela.Direccion;
    }

    export function _GetCiclosEscolaresListFromSchool(idEscuela: number, ciclosActuales = true, ordenar = true) {
        let ciclos = Array.from(_DICC_CICLO_ESCOLAR.values());
        ciclos = ciclos.filter(d => (d.IdEscuela == idEscuela));
        if (!ciclos.length) return ciclos;
        if (ordenar) {
            ciclos = ciclos.sort((a, b) => (Number(new Date(a.FechaInicio)) - Number(new Date(b.FechaInicio))));
        }
        if (ciclosActuales) {
            const ciclosFilter = ciclos.filter(d => UIUtilTime._GetValidatorDateYMD(new Date(d.FechaFin)) >= UIUtilTime._GetValidatorDateYMD(new Date()));
            ciclos = !ciclosFilter.length ? [ciclos[ciclos.length - 1]] : ciclosFilter
        }

        return ciclos;
    }

    export function _GetCurrentCicloEscolar(ciclosEscolaresList: MCicloEscolar[]) {
        if (!ciclosEscolaresList || !ciclosEscolaresList.length) return;
        const now = new Date();
        let cicloEscFound = ciclosEscolaresList
            .find(d => new Date(d.FechaInicio) <= now && new Date(d.FechaFin) >= now);

        if (!cicloEscFound) {
            cicloEscFound = ciclosEscolaresList[0];
        }

        return cicloEscFound;
    }

    export async function _SvUpdateFoto(dato: Partial<IEscuelaForm>, logoFile: File): Promise<DataDRequest.IResultadoPeticion<null>> {
        if (logoFile instanceof File) {
            let res = await _SvEscuelaActualizarLogo(dato.IdKinder, logoFile);

            res.Mensaje = UIUtilLang._GetHTTPMessage(res, "editarlogo");

            return res;
        } else {
            // this.notificacion.fn_Mostrar(controlD3.CDefaultMessage.EscuelaLogoError, controlD3.Notificacion.CTipoNotificacion.ADVERTENCIA);
            console.warn("-d", "Update school photo: Invalid image, should be a File instance!");
            return { Resultado: -1/*  Mensaje: controlD3.CDefaultMessage.EscuelaLogoError  */ }
        }
    }
}